import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, inject} from '@angular/core';
import { InputForm, Button } from 'ustore-ui';
import { RouterModule, Router } from '@angular/router';

import { CartProductItemComponent } from '../cart-product-item/cart-product-item.component';
import { CartProduct, CartProductSuggestion } from '../../../core/models/cart.model';
import { CurrencyBRLPipe } from '../../pipes/currency-brl.pipe';
import { CartService } from '../../services/cart.service';
import { HeaderService } from '../../services/header.service';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-cart-product-list',
  standalone: true,
  imports: [CommonModule, CartProductItemComponent, CurrencyBRLPipe, InputForm, Button, RouterModule, I18nPipe],
  templateUrl: './cart-product-list.component.html',
  styleUrl: './cart-product-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartProductListComponent{ 
  @Input() products: CartProduct[] = [];

  @Output() removePlan = new EventEmitter<{ productId: string; planId: string }>(); 
  @Output() undoRemove = new EventEmitter<{ productId: string; planId: string }>();
  @Output() clearClicked = new EventEmitter<void>();                              
  @Output() changeQty = new EventEmitter<{ productId: string; planId: string; quantity: number }>();
  @Output() suggestionAccept = new EventEmitter<CartProductSuggestion>();
  @Output() suggestionDismiss = new EventEmitter<CartProductSuggestion>();
	@Input() isCartEmpty: boolean = false;
  @Input() suggestionLoadingId: string | null = null;
	@Input() useCategoryLayoutWhenEmpty: boolean = false;
  @Input() showProductTerm: boolean = false;
  @Input() maxQuantityByPlanId: Record<string, number> = {};

  private cartService = inject(CartService);
  private headerService = inject(HeaderService);
  private router = inject(Router);

  get hasProducts(): boolean {
    return (this.products?.length ?? 0) > 0;
  }

  public trackByProductId(index: number, product: CartProduct): string {
      return product.id;
  }

  onRemovePlan(productId: string, planId: string) {
    this.removePlan.emit({ productId, planId });
  }

  clearCart(): void {
    if (this.hasProducts) this.clearClicked.emit();
  }
  
  onUndoRemove(productId: string, planId: string) {
    this.undoRemove.emit({ productId, planId });
  }

  onChangeQty(productId: string, ev: { planId: string; quantity: number }) {
    this.changeQty.emit({ productId, planId: ev.planId, quantity: ev.quantity });
  }

  goToMenu() {
    this.cartService.closeCartSidebar();
    
    const currentUrl = this.router.url.split('?')[0];
    const isHomePage = currentUrl === '/' || currentUrl === '';
    
    if (isHomePage) {
      setTimeout(() => this.scrollToProductCarousel(), 150);
    } else {
      this.router.navigate(['/'], { 
        queryParams: { scrollToProducts: 'true' },
        queryParamsHandling: 'merge'
      });
    }
  }

  private scrollToProductCarousel() {
    const headerHeight = 100;
    const offset = 100;
    
    const element = document.getElementById('category-item');
    if (element) {
      const parentEl = element.parentElement;
      if (parentEl) {
        const elementPosition = parentEl.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        setTimeout(() => window.dispatchEvent(new CustomEvent('resetCarousel')), 400);
      }
    }
  }

}
